<template>
  
    <v-container fluid grid-list-lg>
        <v-card>
          <v-app-bar flat>
            <v-icon>location_city</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Empresas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista de Empresas</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Nombre"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">
                        <tr @click="viewItem(item)">
                        <td class="text-xs-left">{{ item.nombre }}</td>
                        <td class="text-xs-left">{{ item.cuit }}</td>

                        <td class="text-xs-left">                
                          <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                          <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon></td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>location_city</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">
                        <v-icon medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id != null" 
                        :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form  :disabled="!editMode">
                        
                          <v-layout>
                              <v-flex d-flex xs12 sm6 md4>   
                                <div>
                                  <v-avatar :disabled="!editMode" size="150px" v-ripple v-if="!imagenPerfil.url" class="grey lighten-3 mb-3" @click="openFileDialog()">
                                    <span>Clickee para agregar el Logo de la Empresa</span>
                                  </v-avatar>
                                  <v-avatar :disabled="!editMode" size="150px" v-ripple v-else class="mb-3" @click="openFileDialog()">
                                    <img v-bind:src="imagenPerfil.url">
                                </v-avatar>
                                <input :disabled="!editMode" type="file" id="file-upload" style="display:none" @change="onLogoFileChange"> 
                                </div>
                            </v-flex> 
                          
                            <v-flex xs6>
                              <v-text-field v-model="model.nombre" label="Nombre" required :disabled="!editMode" v-validate="'required'" data-vv-name="nombre" :error-messages="errors.collect('nombre')"></v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field v-model="model.nombreFantasia" label="Nombre Fantasía" :disabled="!editMode"></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-row>
                            <v-col cols="4">
                              <v-text-field v-model="model.cuit" label="C.U.I.T." :disabled="!editMode"></v-text-field>
                            </v-col>
                            <v-col>
                              <v-select :disabled="!editMode" :items="listColores" item-text="descripcion" item-value="id" v-model="model.color" label="Se identifica con el color" ></v-select> 
                            </v-col>
                            <v-col cols="4">
                              <v-chip dark :color="model.color">{{model.nombreFantasia}}</v-chip>
                            </v-col>
                          </v-row>
                          
                          <v-text-field v-model="model.iiBb" label="II.BB." :disabled="!editMode"></v-text-field>

                          <v-layout>
                            <v-flex xs12>
                              <v-text-field v-model="model.rutaCertificadoAfip" label="Ruta Certificado Afip" required :disabled="!editMode" ></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-layout>
                            <v-flex xs12 lg6>
                              <v-text-field v-model="model.rutaLegajoVirtual" label="Ruta Legajo Virtual" required :disabled="!editMode" v-show="$store.state.parametrosGenerales.legajoVirtualHabilitado"></v-text-field>
                            </v-flex>
                            <v-flex xs12 lg6>
                              <v-text-field v-model="model.codigoContable" label="Código Cta. Contable" required :disabled="!editMode"></v-text-field>
                            </v-flex>
                          </v-layout>

                          <v-text-field v-model="model.inicioActividadesFormatted" label="Inicio Actividades" type="date" prepend-icon="event" 
                            @input="inicioActividadesChanged" :disabled="!editMode"></v-text-field>
                          
                          <app-domicilio-simple propName= "domicilio" :value="model" :editMode="editMode"></app-domicilio-simple>
<!-- 
                          <v-container  fluid>
                            <v-row>
                              <v-col>
                                <div class="body-1">Parámetros para Débitos por CBU</div>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-switch label="Banco Nación"></v-switch>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-switch label="Banco Itaú"></v-switch>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-switch label="Banco de Comercio"></v-switch>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-switch label="Banco Provincia"></v-switch>
                              </v-col>  
                            </v-row>

                          </v-container> -->

                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>

                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>

</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

import { startOfMonth, endOfMonth, format } from 'date-fns'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Nombre', value: 'nombre' },
        { text: 'Cuit', value: 'cuit' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      model: {},
      imagenPerfil:{file:null,url:''},
      listColores:[{id:"red", descripcion:"Rojo"},
                   {id:"pink", descripcion:"Rosa"},
                   {id:"purple", descripcion:"Púrpura"},
                   {id:"indigo", descripcion:"Índigo"},
                   {id:"blue", descripcion:"Azul"},
                   {id:"light-blue", descripcion:"Celeste"},
                   {id:"green", descripcion:"Verde"},
                   {id:"light-green", descripcion:"Verde Claro"},
                   {id:"lime", descripcion:"Lima"},
                   {id:"yellow", descripcion:"Amarillo"},
                   {id:"orange", descripcion:"Naranja"},
                   {id:"deep-orange", descripcion:"Naraja Obscuro"},
                   {id:"brown", descripcion:"Marrón"},
                   {id:"grey", descripcion:"Gris"},
                   {id:"blue-grey", descripcion:"Gris-Azul"},
                   ]
    };
  },
  async created() {     
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    },
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    inicioActividadesChanged(newDate){
      this.model.inicioActividades = newDate
    },
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {
        var result = await http.get('empresas?nombre='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false') );     

                                    
        this.records = result.list;
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      
      this.loading = true
      this.resetState()

      try { 
        var result = await http.get('empresas/' +id );
        
        if(result.imagenPerfilBase64)
        {
          this.base64ToFile(result.imagenPerfilBase64)
        }
        else{
          this.imagenPerfil.file=null;
          this.imagenPerfil.url = '';
        }

        this.model = result;
        this.model.inicioActividadesFormatted = this.$moment(this.model.inicioActividades).format('YYYY-MM-DD') // creo una prop auxiliar para mostrar la fecha formateada
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      
      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0) return;

      if(this.imagenPerfil.file)
      {
          await this.getBase64(this.imagenPerfil.file).then(res => this.model.imagenPerfilBase64 = res);
      }
      
      if (isUpdate) {
        try{
          var result = await http.put('empresas', JSON.stringify( {empresa:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }               
      } else {
        try{
          Vue.$log.debug(this.model)
          Vue.$log.debug(JSON.stringify({ empresa: this.model} ))
          var result = await http.post('empresas', JSON.stringify( {empresa:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          Vue.$log.error(error);
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación de la empresa ' + item.nombre + '?')) {
        try{
            Vue.$log.debug(item);
            var result = await http.delete('empresas?id='+item.id );
            this.alertSuccess('La empresa ha sido eliminado.')
            this.clearAndReload();
        }
        catch(error){
            //Error
            Vue.$log.error(error);
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('La empresa no puede ser eliminada debido a que está asociada a una o más sucursales.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    openFileDialog() {
        document.getElementById('file-upload').click();
    },
    onFileChange(e) {
      var self = this;
      Vue.$log.debug(e);
      Vue.$log.debug(e.target.files);
      Vue.$log.debug(e.dataTransfer.files);
      var files = e.target.files || e.dataTransfer.files;       
      if(files.length > 0){
          for(var i = 0; i< files.length; i++){
              self.model.rutaCertificado = files[i].name;
          }
      }
    },
    uploadFile() {
      var self = this; 
      axios.post('URL', self.formData).then(function (response) {
            console.log(response);
      }).catch(function (error) {
            console.log(error);
      });
    },
    onLogoFileChange(e) {
      Vue.$log.debug(e);
      Vue.$log.debug(e.target.files);

      var files = e.target.files || e.dataTransfer.files;       
      if(files.length > 0){
          if(!files[0].type.includes('image'))//Chequeo que el archivo sea de tipo imagen
          {
            this.alertWarning('Debe seleccionar un archivo con formato de imagen.');
            return;
          }

          this.imagenPerfil.file = files[0];
          //URL.revokeObjectURL(this.imagenPerfil.url);
          this.imagenPerfil.url = URL.createObjectURL(files[0])
        }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    base64ToFile(url){
      const fullUrl = 'data:image/png;base64,' + url;
      this.model.imagenPerfilBase64 = '';
      fetch(fullUrl)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], "File name")
          
          this.imagenPerfil.url = URL.createObjectURL(file);
          this.imagenPerfil.file=file;
      })
    }
  }
}
</script>